import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { logger } from "@/lib/logger";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // info is not persisted: bot scans of random paths must not fill app_log.
    logger.info("404 Error: User attempted to access non-existent route", {
      path: location.pathname,
    });
  }, [location.pathname]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center space-y-4">
        <div className="text-6xl"><span aria-hidden="true" style={{ display: "inline-block", transform: "scaleX(-1)" }}>🏃‍♂️</span><span aria-hidden="true">💨</span></div>
        <h1 className="text-5xl font-black text-foreground">404</h1>
        <p className="text-lg text-muted-foreground">
          This page ran off the course!
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-bold bg-primary text-primary-foreground hover:opacity-90 transition-opacity"
        >
          Back to start line
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
